import { render } from "./BulkAnalyticsModal.vue?vue&type=template&id=71635fba&scoped=true"
import script from "./BulkAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./BulkAnalyticsModal.vue?vue&type=script&lang=js"

import "./BulkAnalyticsModal.vue?vue&type=style&index=0&id=71635fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71635fba"]])

export default __exports__